import { useApiMutation, useApiQuery } from "../services/react-query";

export const useGetPages = (params, queryOptions = {}) =>
  useApiQuery({
    queryOptions: { queryKey: ["pages", params], ...queryOptions },
    fetchOptions: { url: "/pages", method: "GET", params },
  });

export const useGetPage = (id) =>
  useApiQuery({
    queryOptions: { queryKey: ["page", { id }], enabled: !!id },
    fetchOptions: { url: `/pages/${id}`, method: "GET" },
  });

export const usePatchPage = (id) =>
  useApiMutation({
    mutationOptions: { mutationKey: "usePatchPage" },
    fetchOptions: { url: `/pages/${id}`, method: "PATCH" },
    invalidateQueryKeys: [["pages"], ["page", { id }]],
    successMessage: { title: "Page has been updated", color: "green" },
  });

export const useCreatePage = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCreatePage" },
    fetchOptions: { url: "/pages", method: "POST" },
    invalidateQueryKeys: [["pages"]],
    successMessage: { title: "Page has been created", color: "green" },
  });

export const useDeletePage = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeletePage" },
    fetchOptions: { url: `/pages`, method: "DELETE" },
    invalidateQueryKeys: [["pages"]],
    successMessage: { title: "Page has been deleted", color: "green" },
  });

export const useUpdatePagesOrder = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useUpdatePagesOrder" },
    fetchOptions: { url: "/pages/order", method: "PATCH" },
    invalidateQueryKeys: [["pages"]],
    successMessage: {
      title: "Pages reordered successfully",
      color: "green",
    },
  });
